/**
 * Fadelessart Customizer -- Full Interactive Edition
 * 
 * Key improvements over previous version:
 * 1. Real Shopify variant binding via VariantData JSON
 * 2. Orientation tabs (Landscape/Portrait/Square) with dynamic size grid
 * 3. Smart size suggestion from uploaded image aspect ratio
 * 4. ALL selections (edge, depth, frame, filter, layout) update the preview visually
 * 5. Pricing breakdown in bottom bar (size + frame + filter + service)
 * 6. Quantity selector
 * 7. Dynamic room preview (user's image composited on wall)
 * 8. Frame/edge/depth visually rendered on the preview canvas
 */
(function() {
  'use strict';

  // -- Parse variant data from template --
  var variantDataEl = document.getElementById('VariantData');
  var VARIANT_MAP = {};
  if (variantDataEl) {
    try { VARIANT_MAP = JSON.parse(variantDataEl.textContent); } catch(e) {}
  }

  // -- AI filter config --
  var API_BASE_URL = (window.theme && window.theme.aiApiEndpoint) || 'https://fadelessart-api-production.up.railway.app';
  var AI_FILTERS = ['oil', 'paint', 'comic', 'vintage', 'colorisolate', 'rembrandt', 'vangogh', 'monet'];

  // -- State --
  var state = {
    image: null,
    imageFile: null,
    imageWidth: 0,
    imageHeight: 0,
    imageQuality: null,
    orientation: 'landscape',
    size: { display: '20" x 16"', variant: 50239782617328, price: 59.00, orig: 118.00 },
    layout: 'single',
    panelImages: [null, null, null, null],  // up to 4 slots, fall back to state.image
    edge: { id: 'photo-wrap', name: 'Photo Wrap' },
    depth: '0.75',
    frame: { id: 'none', name: 'None', price: 0 },
    filter: { id: 'none', name: 'None', css: '', price: 0 },
    service: { id: 'none', name: 'None', price: 0 },
    notes: '',
    quantity: 1,
    is3DMode: false,
    isCustomSize: false,
    aiImage: null,
    aiImageStyle: null,
    aiProcessing: false
  };

  var $ = function(id) { return document.getElementById(id); };
  var dom = {};

  function cacheDom() {
    dom = {
      uploadZone: $('UploadZone'), fileInput: $('FileInput'),
      uploadIcon: $('UploadIcon'), uploadPrompt: $('UploadPrompt'),
      uploadThumb: $('UploadThumb'), changeBtn: $('ChangeBtn'),
      uploadInfo: $('UploadInfo'), qualityFill: $('QualityFill'), qualityText: $('QualityText'),
      previewStage: $('PreviewStage'), previewCanvasWrap: $('PreviewCanvasWrap'),
      frameOuter: $('FrameOuter'), canvasEdge: $('CanvasEdge'), canvasFront: $('CanvasFront'),
      previewImage: $('PreviewImage'), uploadPlaceholder: $('UploadPlaceholder'),
      toggle2DBtn: $('Toggle2DBtn'), toggle3DBtn: $('Toggle3DBtn'),
      rotationControls: $('RotationControls'),
      preview3DContainer: $('Preview3DContainer'),
      orientationTabs: $('OrientationTabs'), sizeGrid: $('SizeGrid'),
      sizeRec: $('SizeRecommendation'), recText: $('RecommendationText'),
      customW: $('customW'), customH: $('customH'), applyCustomSize: $('ApplyCustomSize'),
      tabNav: $('tabNav'), optionsPane: $('optionsPane'),
      roomPreviewImg: $('RoomPreviewImg'), roomCanvasOverlay: $('RoomCanvasOverlay'),
      bbSize: $('bbSize'), bbPrice: $('bbPrice'), bbOrig: $('bbOrig'),
      bbBreakSize: $('bbBreakSize'), bbBreakFrame: $('bbBreakFrame'),
      bbBreakFilter: $('bbBreakFilter'), bbBreakService: $('bbBreakService'),
      bbFinal: $('bbFinal'),
      qtyMinus: $('QtyMinus'), qtyPlus: $('QtyPlus'), qtyInput: $('QtyInput'),
      addToCartBtn: $('AddToCartBtn'), designerNotes: $('designerNotes')
    };
  }

  // ===========================================
  // UPLOAD
  // ===========================================
  function initUpload() {
    if (!dom.uploadZone) return;
    // Fix: remove 'hidden' attr which blocks .click() in Safari/some browsers
    // Replace with cross-browser-safe invisible CSS
    if (dom.fileInput) {
      dom.fileInput.removeAttribute('hidden');
      dom.fileInput.style.cssText = 'position:absolute;opacity:0;width:1px;height:1px;pointer-events:none;overflow:hidden;border:0;padding:0;margin:0;left:-9999px;';
    }
    var lastFileClick = 0;
    dom.uploadZone.addEventListener('click', function(e) {
      if (e.target.id !== 'ChangeBtn' && !e.target.closest('#ChangeBtn')) {
        var now = Date.now();
        if (now - lastFileClick < 800) return; // prevent double-fire with inline onclick
        lastFileClick = now;
        if (dom.fileInput) dom.fileInput.click();
      }
    });
    dom.uploadZone.addEventListener('dragover', function(e) {
      e.preventDefault(); dom.uploadZone.classList.add('drag-over');
    });
    dom.uploadZone.addEventListener('dragleave', function() {
      dom.uploadZone.classList.remove('drag-over');
    });
    dom.uploadZone.addEventListener('drop', function(e) {
      e.preventDefault(); dom.uploadZone.classList.remove('drag-over');
      if (e.dataTransfer.files.length > 0) handleFile(e.dataTransfer.files[0]);
    });
    if (dom.fileInput) {
      dom.fileInput.addEventListener('change', function(e) {
        if (e.target.files.length > 0) handleFile(e.target.files[0]);
      });
    }
    if (dom.changeBtn) {
      dom.changeBtn.addEventListener('click', function(e) {
        e.stopPropagation(); dom.fileInput.click();
      });
    }
  }

  function handleFile(file) {
    if (!file.type.startsWith('image/')) {
      showToast('Please upload an image file (JPG, PNG, TIFF)', 'error'); return;
    }
    if (file.size > 100 * 1024 * 1024) {
      showToast('File too large. Maximum 100MB.', 'error'); return;
    }
    state.imageFile = file;
    var reader = new FileReader();
    reader.onload = function(ev) {
      state.image = ev.target.result;
      updateUploadArea();
      updatePreview();
      updateRoomPreview();
      assessImageQuality(file, ev.target.result);
      updateAIBtn();
      showToast('Photo uploaded! Preview updated.', 'success');
    };
    reader.readAsDataURL(file);
  }

  function updateUploadArea() {
    if (!dom.uploadZone) return;
    dom.uploadZone.classList.add('has-image');
    if (dom.uploadPrompt) dom.uploadPrompt.style.display = 'none';
    if (dom.uploadIcon) dom.uploadIcon.style.display = 'none';
    if (dom.uploadThumb) { dom.uploadThumb.src = state.image; dom.uploadThumb.style.display = 'block'; }
    if (dom.changeBtn) dom.changeBtn.style.display = 'inline-block';
  }

  function assessImageQuality(file, dataUrl) {
    var img = new Image();
    img.onload = function() {
      state.imageWidth = img.width;
      state.imageHeight = img.height;
      var minDim = Math.min(img.width, img.height);
      var quality, percent, text;
      if (minDim >= 3000) { quality = 'excellent'; percent = 100; text = 'Excellent quality -- perfect for any size'; }
      else if (minDim >= 2000) { quality = 'good'; percent = 80; text = 'Good quality -- great for medium to large prints'; }
      else if (minDim >= 1000) { quality = 'fair'; percent = 55; text = 'Fair quality -- best for smaller sizes'; }
      else { quality = 'low'; percent = 30; text = 'Low resolution -- may affect print quality at larger sizes'; }
      state.imageQuality = quality;
      if (dom.uploadInfo) dom.uploadInfo.style.display = 'block';
      if (dom.qualityFill) dom.qualityFill.style.width = percent + '%';
      if (dom.qualityText) dom.qualityText.textContent = text;
      recommendSizeByAspectRatio();
    };
    img.src = dataUrl;
  }

  // -- Smart size suggestion --
  function recommendSizeByAspectRatio() {
    if (!state.imageWidth || !state.imageHeight || !dom.sizeRec) return;
    var ratio = state.imageWidth / state.imageHeight;
    var orient, recommended;
    if (ratio > 1.2) orient = 'landscape';
    else if (ratio < 0.85) orient = 'portrait';
    else orient = 'square';

    // Auto-switch orientation tab
    if (orient !== state.orientation) {
      switchOrientation(orient);
    }

    // Suggest best size based on quality
    var sizes = VARIANT_MAP[orient] || [];
    if (state.imageQuality === 'low' && sizes.length > 0) recommended = sizes[0];
    else if (state.imageQuality === 'fair' && sizes.length > 1) recommended = sizes[1];
    else if (sizes.length > 2) recommended = sizes[2];
    else if (sizes.length > 0) recommended = sizes[0];

    if (recommended && dom.recText) {
      dom.recText.textContent = 'Recommended: ' + recommended.display + ' based on your photo (' + state.imageWidth + 'x' + state.imageHeight + 'px, ' + state.imageQuality + ' quality)';
      dom.sizeRec.style.display = 'flex';
    }
  }

  // ===========================================
  // ORIENTATION TABS + SIZE GRID
  // ===========================================
  function initOrientation() {
    var tabs = document.querySelectorAll('.orient-tab');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');
        switchOrientation(tab.dataset.orient);
      });
    });
    buildSizeGrid();
  }

  function switchOrientation(orient) {
    state.orientation = orient;
    var tabs = document.querySelectorAll('.orient-tab');
    tabs.forEach(function(t) { t.classList.toggle('active', t.dataset.orient === orient); });
    buildSizeGrid();
  }

  function buildSizeGrid() {
    if (!dom.sizeGrid) return;
    var sizes = VARIANT_MAP[state.orientation] || [];
    var html = '';
    sizes.forEach(function(s, i) {
      var sel = (s.display === state.size.display) ? ' selected' : '';
      var dispEsc = String(s.display).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;');
      // Parse dimensions for thumb shape
      var dimParts = String(s.display).replace(/&quot;|"/g,'').split('x').map(function(p){return parseInt(p.trim(),10)||0;});
      var dw = dimParts[0] || 4, dh = dimParts[1] || 3;
      var ar = dw / dh;
      // Cap aspect ratio so all thumbs look reasonable
      var thumbStyle = ar > 1 ? 'aspect-ratio:' + ar.toFixed(2) + '/1;width:80%;margin:0 auto;'
                          : 'aspect-ratio:1/' + (1/ar).toFixed(2) + ';height:80%;margin:auto 0;';
      html += '<div class="size-card' + sel + '" data-variant="' + s.variant + '" data-display="' + dispEsc + '" data-price="' + s.price + '" data-orig="' + s.orig + '">'
            + '<div class="size-thumb" style="display:flex;align-items:center;justify-content:center"><div style="' + thumbStyle + 'background:linear-gradient(180deg,var(--cream),var(--cream-dark));border:1.5px solid var(--navy);border-radius:1px;box-shadow:0 2px 4px rgba(0,0,0,.12)"></div></div>'
            + '<div class="size-name">' + s.display + '</div>'
            + '<div class="size-price">$' + s.price.toFixed(2) + ' <span class="orig">$' + s.orig.toFixed(2) + '</span></div>'
            + '<div class="size-cta">Select</div>'
            + '</div>';
    });
    dom.sizeGrid.innerHTML = html;

    // Bind click events
    var cards = dom.sizeGrid.querySelectorAll('.size-card');
    cards.forEach(function(card) {
      card.addEventListener('click', function() {
        cards.forEach(function(c) { c.classList.remove('selected'); });
        card.classList.add('selected');
        state.size = {
          display: card.dataset.display,
          variant: parseInt(card.dataset.variant),
          price: parseFloat(card.dataset.price),
          orig: parseFloat(card.dataset.orig)
        };
        state.isCustomSize = false;
        // Clear custom-size card selected state
        var customCard = document.getElementById('CustomSizeCard') || document.querySelector('.size-custom-card');
        if (customCard) customCard.classList.remove('selected');
        updatePreview();
        flashPreviewSizeLabel(state.size.display, state.orientation);
        updateBottomBar();
      });
    });
  }

  // -- Flash the preview size label briefly when a size is chosen --
  function flashPreviewSizeLabel(display, orient) {
    var label = document.getElementById('PreviewSizeLabel');
    if (!label) return;
    var nice = String(display).replace(/"/g, '\u2033');
    var orientSpan = label.querySelector('.psl-orient');
    if (orientSpan) {
      label.firstChild.textContent = nice + ' ';
      orientSpan.textContent = orient || 'landscape';
    } else {
      label.innerHTML = nice + '<span class="psl-orient">' + (orient || 'landscape') + '</span>';
    }
    label.classList.add('visible');
    clearTimeout(label._hideTimer);
    label._hideTimer = setTimeout(function() {
      label.classList.remove('visible');
    }, 1600);
  }

  function applyCustomSize(w, h) {
    if (!w || !h) {
      w = parseInt(dom.customW ? dom.customW.value : 0, 10);
      h = parseInt(dom.customH ? dom.customH.value : 0, 10);
    }
    if (!w || !h || w < 8 || h < 8 || w > 72 || h > 72) {
      showToast('Please enter sizes between 8 and 72 inches', 'error'); return;
    }
    // Find closest variant
    var sizes = VARIANT_MAP[state.orientation] || [];
    var closest = sizes[0];
    var minDiff = 999999;
    sizes.forEach(function(s) {
      // Display format: '10" x 8"' -- strip quotes then split on ' x '
      var cleaned = String(s.display).replace(/"/g, '');
      var parts = cleaned.split(' x ');
      var sw = parseInt(parts[0], 10) || 0;
      var sh = parseInt(parts[1], 10) || 0;
      var diff = Math.abs(sw - w) + Math.abs(sh - h);
      if (diff < minDiff) { minDiff = diff; closest = s; }
    });
    state.size = {
      display: w + '" x ' + h + '"',
      variant: closest.variant,
      price: closest.price,
      orig: closest.orig
    };
    // Update finished size text
    var finishedEl = document.getElementById('customFinished');
    if (finishedEl) finishedEl.textContent = w + '" x ' + h + '"';

    // Mark custom-size-card as selected, clear preset size cards
    var customCard = document.getElementById('CustomSizeCard') || document.querySelector('.size-custom-card');
    if (customCard) customCard.classList.add('selected');
    var sizeCards = document.querySelectorAll('#SizeGrid .size-card');
    sizeCards.forEach(function(c) { c.classList.remove('selected'); });

    updateBottomBar();
    updatePreview();
    flashPreviewSizeLabel(state.size.display, state.orientation);
    state.isCustomSize = true;
  }

  // -- Custom size card click handler (no longer collapsed) --
  function initCustomSizeToggle() {
    var card = document.getElementById('CustomSizeCard');
    if (!card) return;
    // Click on card area (not on form fields) to apply with current W/H
    card.addEventListener('click', function(e) {
      // Avoid triggering when interacting with selects (let user browse freely)
      if (e.target.closest('.cs-select') || e.target.closest('select')) return;
      // Apply on card-level click OR when user finishes a change (change event below)
      var w = dom.customW ? parseInt(dom.customW.value, 10) : 0;
      var h = dom.customH ? parseInt(dom.customH.value, 10) : 0;
      if (w > 0 && h > 0) applyCustomSize(w, h);
    });
    // Auto-apply when user changes W or H
    function bindAutoApply(el) {
      if (!el) return;
      el.addEventListener('change', function() {
        var w = parseInt(dom.customW.value, 10);
        var h = parseInt(dom.customH.value, 10);
        if (w > 0 && h > 0) applyCustomSize(w, h);
      });
    }
    bindAutoApply(dom.customW);
    bindAutoApply(dom.customH);
  }

// ===========================================
// LAYOUT SELECTION -- multi-panel split / grid
// ===========================================
function initLayout() {
  var cards = document.querySelectorAll('#LayoutGrid .layout-card');
  if (!cards.length) return;
  cards.forEach(function(card) {
    card.addEventListener('click', function() {
      cards.forEach(function(c) { c.classList.remove('selected'); });
      card.classList.add('selected');
      state.layout = card.dataset.layout || 'single';
      rebuildUploadSlots();
      updatePreview();
      updateBottomBar();
    });
  });
}

// Build per-panel upload slots based on current layout
// Only render for multi-panel layouts (split-2/split-3/grid-4); single layout reuses main upload
function rebuildUploadSlots() {
  var container = document.getElementById('UploadSlots');
  if (!container) return;
  var count = panelCountFor(state.layout);
  // Single-panel layout: hide the slot container to avoid duplicate upload UI
  if (count <= 1) {
    container.innerHTML = '';
    container.style.display = 'none';
    return;
  }
  container.style.display = '';
  var html = '';
  for (var i = 0; i < count; i++) {
    var hasImg = state.panelImages[i];
    html += '<div class="upload-slot" data-slot="' + i + '">'
         +  '<label class="slot-label">Panel ' + (i + 1) + '</label>'
         +  '<div class="slot-inner">'
         +  (hasImg
              ? '<img class="slot-thumb" src="' + hasImg + '">'
              : '<span class="slot-placeholder">Click to upload</span>')
         +  '</div>'
         +  '<input type="file" accept="image/*" class="slot-file-input" hidden>'
         +  '</div>';
  }
  container.innerHTML = html;

  // Bind each slot
  var slots = container.querySelectorAll('.upload-slot');
  slots.forEach(function(slot) {
    var idx = parseInt(slot.dataset.slot, 10);
    var inner = slot.querySelector('.slot-inner');
    var input = slot.querySelector('.slot-file-input');
    if (inner) {
      inner.addEventListener('click', function() { input.click(); });
    }
    if (input) {
      input.addEventListener('change', function(e) {
        if (e.target.files && e.target.files[0]) {
          var file = e.target.files[0];
          var reader = new FileReader();
          reader.onload = function(ev) {
            state.panelImages[idx] = ev.target.result;
            rebuildUploadSlots();
            updatePreview();
            showToast('Panel ' + (idx + 1) + ' image uploaded', 'success');
          };
          reader.readAsDataURL(file);
        }
      });
    }
  });
}

function panelCountFor(layout) {
  switch (layout) {
    case 'split-2': return 2;
    case 'split-3': return 3;
    case 'grid-4':  return 4;
    default:         return 1;
  }
}

  // ===========================================
  // EDGE + DEPTH SELECTION (NOW UPDATES PREVIEW)
  // ===========================================
  function initEdge() {
    var edgeCards = document.querySelectorAll('#EdgeList .edge-card');
    edgeCards.forEach(function(card) {
      card.addEventListener('click', function() {
        edgeCards.forEach(function(c) { c.classList.remove('selected'); });
        card.classList.add('selected');
        state.edge = { id: card.dataset.edge, name: card.dataset.name };
        updatePreview();
      });
    });
  }

  // Build HTML for a single split panel wrapped in mini frame/edge (continuous split-line gets frame treatment)
  function buildSplitPanel(src) {
    var frameId = state.frame ? state.frame.id : 'none';
    var edgeId = state.edge ? state.edge.id : 'photo-wrap';
    var useAI = state.aiImage && state.aiImageStyle === state.filter.id;
    var filterCss = useAI ? 'none' : (state.filter && state.filter.css ? state.filter.css : 'none');
    var imgStyle = 'filter:' + filterCss + ';width:100%;height:100%;object-fit:cover';
    return '<div class="preview-split-panel">' +
           '<div class="psp-frame" data-frame="' + frameId + '">' +
           '<div class="psp-edge" data-edge="' + edgeId + '">' +
           (src ? '<img src="' + src + '" style="' + imgStyle + '">' : '<div class="psp-empty"></div>') +
           '</div></div></div>';
  }

  // ===========================================
  // FRAME SELECTION (NOW UPDATES PREVIEW VISUALLY)
  // ===========================================
  function initFrame() {
    var rows = document.querySelectorAll('#FrameList .frame-card-row, #FrameList .frame-card-grid');
    rows.forEach(function(row) {
      row.addEventListener('click', function() {
        rows.forEach(function(r) { r.classList.remove('selected'); });
        row.classList.add('selected');
        state.frame = {
          id: row.dataset.frame,
          name: row.dataset.name,
          price: parseFloat(row.dataset.price) || 0
        };
        updatePreview();
        updateBottomBar();
      });
    });
    // Canvas Depth (now lives in Frames tab, moved from Edges)
    var depthOpts = document.querySelectorAll('#pane-frames .depth-option');
    depthOpts.forEach(function(opt) {
      opt.addEventListener('click', function() {
        depthOpts.forEach(function(d) { d.classList.remove('selected'); });
        opt.classList.add('selected');
        state.depth = opt.dataset.depth;
        updatePreview();
      });
    });
  }

  // ===========================================
  // FILTER SELECTION
  // ===========================================
  function initFilter() {
    var rows = document.querySelectorAll('#FilterList .filter-row');
    rows.forEach(function(row) {
      row.addEventListener('click', function() {
        rows.forEach(function(r) { r.classList.remove('selected'); });
        row.classList.add('selected');
        var newFilterId = row.dataset.filter;
        var isAI = AI_FILTERS.indexOf(newFilterId) !== -1;
        var wasAI = state.filter && AI_FILTERS.indexOf(state.filter.id) !== -1;
        state.filter = {
          id: newFilterId,
          name: row.dataset.name,
          css: row.dataset.css,
          price: parseFloat(row.dataset.price) || 0
        };

        // If switching to a different filter, clear stale AI image
        if (state.aiImageStyle && state.aiImageStyle !== state.filter.id) {
          state.aiImage = null;
          state.aiImageStyle = null;
        }

        updatePreview();
        updateBottomBar();
        updateAIBtn();

        // -- AUTO-TRIGGER AI: switch to AI filter + user has image → debounce 600ms and auto-call API --
        if (isAI && state.image && !state.aiProcessing) {
          clearTimeout(state._aiAutoTimer);
          state._aiAutoTimer = setTimeout(function() {
            // Only proceed if still selected
            if (state.filter.id === newFilterId && !state.aiImage) {
              applyAIFilter();
            }
          }, 600);
        }
      });
    });
  }

  // -- AI filter button: show/hide and handle click --
  function updateAIBtn() {
    var btn = document.getElementById('AIFilterBtn');
    var intensityWrap = document.getElementById('AIIntensityWrap');
    var isAI = AI_FILTERS.indexOf(state.filter.id) !== -1;
    var hasImage = !!state.image;
    var alreadyProcessed = state.aiImageStyle === state.filter.id;

    if (!isAI || !hasImage) {
      if (btn) btn.style.display = 'none';
      if (intensityWrap) intensityWrap.style.display = 'none';
      return;
    }

    // Build the AI button only (intensity selector hidden — internal aiIntensity defaults to 'balanced')
    if (!btn) {
      var pane2 = document.getElementById('pane-filters') || document.getElementById('section-filters');
      btn = document.createElement('button');
      btn.id = 'AIFilterBtn';
      btn.style.cssText = 'display:none;margin-top:8px;padding:10px 20px;background:#534AB7;color:#fff;border:none;border-radius:8px;font-size:13px;font-weight:500;cursor:pointer;width:100%;transition:background .2s';
      btn.addEventListener('mouseenter', function() { btn.style.background = '#3C3489'; });
      btn.addEventListener('mouseleave', function() { btn.style.background = '#534AB7'; });
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        applyAIFilter();
      });
      pane2.appendChild(btn);
    }

    btn.style.display = 'block';
    btn.disabled = false;
    btn.style.opacity = '1';
    if (alreadyProcessed) {
      btn.textContent = state.filter.name + ' style applied';
      btn.style.background = '#0F6E56';
    } else {
      btn.textContent = 'Apply ' + state.filter.name + ' style';
      btn.style.background = '#534AB7';
    }
  }

  // ===========================================
  // AI ARTISTIC INTENSITY (defaults to 'subtle' for portrait photos)
  // ===========================================
  // Subtle   = 0.55x prompt_strength — best for portrait photos, preserves faces.
  // Balanced = 1.0x — current tuned values.
  // Bold     = 1.30x — most obvious style, may alter faces (for landscapes/art).
  // ===========================================
  var aiIntensity = 'balanced';  // Default to balanced for visible AI effect on first try

  // ===========================================
  // AI MODE — composition vs face-locking
  // ===========================================
  // 'composition' (default) → SDXL img2img, keeps original photo's composition,
  //                           positions, and framing. Best for "change style,
  //                           keep my photo's layout" (most customers).
  //                           Cost: ~$0.005/run, ~5-15s.
  // 'face'                  → InstantID, locks ONE face identity while
  //                           re-rendering scene. Use when face accuracy matters
  //                           more than layout. Cost: ~$0.067/run, ~10-60s.
  //                           Only preserves the largest face in group photos.
  // ===========================================
  var aiPortraitMode = false;  // Default: preserve composition (current customer pain point)

  // -- Call backend AI style transfer API --
  function applyAIFilter() {
    if (!state.image || state.aiProcessing) return;
    if (AI_FILTERS.indexOf(state.filter.id) === -1) return;

    var btn = document.getElementById('AIFilterBtn');
    var style = state.filter.id;
    var origText = btn ? btn.textContent : '';

    state.aiProcessing = true;
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Applying ' + state.filter.name + ' style...';
      btn.style.opacity = '0.7';
    }

    // Show loading overlay on preview
    var overlay = document.createElement('div');
    overlay.id = 'AILoadingOverlay';
    overlay.style.cssText = 'position:absolute;inset:0;background:rgba(255,255,255,0.8);display:flex;align-items:center;justify-content:center;z-index:10;border-radius:8px;font-size:14px;color:#534AB7;font-weight:500';
    var overlayMsg = aiPortraitMode
      ? '<div style="text-align:center"><div style="font-size:24px;margin-bottom:8px">&bull;&bull;&bull;</div>Rendering ' + state.filter.name + ' style...<br><span style="font-size:11px;color:#888">(10-60s)</span></div>'
      : '<div style="text-align:center"><div style="font-size:24px;margin-bottom:8px">&bull;&bull;&bull;</div>Applying ' + state.filter.name + ' style...<br><span style="font-size:11px;color:#888">(5-15s)</span></div>';
    overlay.innerHTML = overlayMsg;
    if (dom.previewCanvasWrap) {
      dom.previewCanvasWrap.style.position = 'relative';
      dom.previewCanvasWrap.appendChild(overlay);
    }

    // Read user's custom prompt from the textarea (if any) for this artist style
    var userPrompt = '';
    try {
      var promptEl = document.querySelector('.artist-prompt-wrap[data-for-filter="' + style + '"] .artist-prompt-input');
      if (promptEl && promptEl.value && promptEl.value.trim().length > 0) {
        userPrompt = promptEl.value.trim().slice(0, 500);  // cap to 500 chars
      }
    } catch(e) { /* no-op */ }

    fetch(API_BASE_URL + '/api/ai/style-transfer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        image: state.image,
        style: style,
        intensity: aiIntensity,
        portraitMode: aiPortraitMode,
        userPrompt: userPrompt
      })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('API error ' + res.status);
      return res.json();
    })
    .then(function(data) {
      // Shopify CSP is img-src 'self' data:; — cross-origin CDN URLs (Railway, R2) are blocked.
      // Prefer processedImage (data URL, CSP-safe) over r2Url/imageUrl which may be cross-origin.
      var processedUrl = data.processedImage || data.r2Url || data.imageUrl;
      if (!processedUrl) throw new Error('No image in response');

      state.aiImage = processedUrl;
      state.aiImageStyle = style;
      state.aiProcessing = false;

      // Remove overlay
      var ov = document.getElementById('AILoadingOverlay');
      if (ov) ov.remove();

      // Update button
      if (btn) {
        btn.textContent = state.filter.name + ' style applied';
        btn.style.background = '#0F6E56';
        btn.disabled = true;
      }

      showToast(state.filter.name + ' style applied!', 'success');
      updatePreview();
    })
    .catch(function(err) {
      console.error('[AI Filter] Error:', err);
      state.aiProcessing = false;

      // Remove overlay
      var ov = document.getElementById('AILoadingOverlay');
      if (ov) ov.remove();

      // Reset button
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'Retry ' + state.filter.name;
        btn.style.opacity = '1';
      }

      showToast('Style render failed. CSS preview still active. (' + err.message + ')', 'error');
    });
  }

  // ===========================================
  // SERVICE SELECTION
  // ===========================================
  function initService() {
    var rows = document.querySelectorAll('#ServiceList .service-row');
    rows.forEach(function(row) {
      row.addEventListener('click', function() {
        rows.forEach(function(r) { r.classList.remove('selected'); });
        row.classList.add('selected');
        state.service = {
          id: row.dataset.service,
          name: row.dataset.name,
          price: parseFloat(row.dataset.price) || 0
        };
        updateBottomBar();
      });
    });
  }

  // ===========================================
  // PREVIEW UPDATE -- THE CORE FUNCTION
  // Updates: image, filter, layout, frame, edge, depth
  // ===========================================
  function updatePreview() {
    if (!dom.previewCanvasWrap) { console.warn('PreviewCanvasWrap not found'); return; }

    // Clear old split/grid content
    if (dom.canvasFront) {
      var oldContent = dom.canvasFront.querySelectorAll('.preview-split, .preview-grid-4');
      oldContent.forEach(function(el) { el.remove(); });
      // Toggle oil brushstroke overlay class based on active filter
      if (state.filter && state.filter.id === 'oil') {
        dom.canvasFront.classList.add('has-oil-effect');
      } else {
        dom.canvasFront.classList.remove('has-oil-effect');
      }
    }

    // Reset wrapper data attributes
    dom.previewCanvasWrap.dataset.frame = state.frame.id;
    dom.previewCanvasWrap.dataset.edge = state.edge.id;
    dom.previewCanvasWrap.dataset.depth = state.depth;

    // ---- Aspect ratio from size.display ('20" x 16"') ----
    // Convention: size name is always "short x long" (e.g. "8 x 10" short x long).
    // Orientation determines physical axis mapping:
    //   landscape -> w = long,  h = short (wide picture)
    //   portrait  -> w = short, h = long  (tall picture)
    //   square    -> equal
    var sizeStr = (state.size && state.size.display) || '20" x 16"';
    var cleanStr = String(sizeStr).replace(/"/g, '');
    var parts = cleanStr.split(' x ');
    var dW = parseInt(parts[0], 10) || 16;  // first dimension (landscape: width; portrait: width; square: edge)
    var dH = parseInt(parts[1], 10) || 20;  // second dimension
    var w, h;
    // Convention: for landscape, parts[0] is wider (e.g. "10\" x 8\"" -> w=10, h=8)
    // For portrait, parts[0] is narrower (e.g. "8\" x 10\"" -> w=8, h=10)
    if (state.orientation === 'portrait')      { w = dW; h = dH; }
    else if (state.orientation === 'landscape') { w = dW; h = dH; }
    else if (state.orientation === 'square')    { w = h = Math.max(dW, dH); }
    else                                        { w = dW; h = dH; }

    // Set CSS variables consumed by .preview-canvas-wrap rule
    dom.previewCanvasWrap.style.setProperty('--canvas-w', w);
    dom.previewCanvasWrap.style.setProperty('--canvas-h', h);
    dom.previewCanvasWrap.style.setProperty('--canvas-ratio', w + ' / ' + h);

    // Adjust max-width based on shape so very wide or very tall sizes look proportional
    var maxW = 560;
    if (h > w * 1.4) maxW = 380;        // tall portrait — narrower to keep visible
    else if (w > h * 1.4) maxW = 640;   // wide landscape — wider
    dom.previewCanvasWrap.style.maxWidth = maxW + 'px';

    // Update floating size label (live visual feedback)
    var sizeLabel = document.getElementById('PreviewSizeLabel');
    if (sizeLabel) {
      sizeLabel.innerHTML = w + '″ × ' + h + '″<span class="psl-orient">' + (state.orientation || 'landscape') + '</span>';
      sizeLabel.classList.add('visible');
      clearTimeout(window.__pslTimer);
      window.__pslTimer = setTimeout(function() { sizeLabel.classList.remove('visible'); }, 1800);
    }

    // Pulse animation on size change
    dom.previewCanvasWrap.classList.remove('size-pulse');
    void dom.previewCanvasWrap.offsetWidth; // restart animation
    dom.previewCanvasWrap.classList.add('size-pulse');

    // Frame outer: just set data-frame, CSS handles all styling (3D bevel + grain)
    if (dom.frameOuter) {
      dom.frameOuter.dataset.frame = state.frame.id;
    }

    // Edge styling
    var edgeStyles = {
      'photo-wrap': { background: 'transparent' },
      'black': { background: '#1a1a2e' },
      'white': { background: '#fff' },
      'blur': { background: 'rgba(134,134,133,0.6)', filter: 'blur(3px)' }
    };
    var es = edgeStyles[state.edge.id] || edgeStyles['photo-wrap'];
    if (dom.canvasEdge) {
      dom.canvasEdge.style.background = es.background;
      dom.canvasEdge.style.filter = es.filter || 'none';
      // Only apply padding (depth simulation) for visible edges; photo-wrap is transparent so padding would expose parent bg
      var visibleEdges = ['black', 'white', 'blur'];
      var depthPx = visibleEdges.indexOf(state.edge.id) >= 0
        ? (state.depth === '1.25' ? '12px' : '8px')
        : '0px';
      dom.canvasEdge.style.padding = depthPx;
    }

    // Image / placeholder
    if (!state.image) {
      if (dom.previewImage) dom.previewImage.style.display = 'none';
      if (dom.uploadPlaceholder) dom.uploadPlaceholder.style.display = 'flex';
      return;
    }
    if (dom.uploadPlaceholder) dom.uploadPlaceholder.style.display = 'none';

    // Use AI-processed image if available for current filter; otherwise CSS filter on original
    var useAIImage = state.aiImage && state.aiImageStyle === state.filter.id;
    var filterCss = useAIImage ? 'none' : (state.filter.css || 'none');
    var panelImgs = state.panelImages || [null, null, null, null];
    var primaryImage = useAIImage ? state.aiImage : (state.image || panelImgs[0]);

    function panelSrc(idx) {
      // Real per-panel image if uploaded, else fall back to state.image for slots 0
      return panelImgs[idx] || (idx === 0 ? state.image : null);
    }

    if (state.layout === 'single' || !state.layout) {
      if (dom.previewImage) {
        dom.previewImage.src = primaryImage;
        dom.previewImage.style.display = primaryImage ? 'block' : 'none';
        dom.previewImage.style.filter = filterCss;
        dom.previewImage.style.width = '100%';
        dom.previewImage.style.height = '100%';
        dom.previewImage.style.objectFit = 'cover';
      }
    } else if (state.layout === 'split-2') {
      if (dom.previewImage) dom.previewImage.style.display = 'none';
      var w2 = document.createElement('div');
      w2.className = 'preview-split preview-split-2';
      var s2a = panelSrc(0) || primaryImage;
      var s2b = panelSrc(1) || s2a;
      w2.innerHTML = buildSplitPanel(s2a) + buildSplitPanel(s2b);
      if (dom.canvasFront) dom.canvasFront.appendChild(w2);
    } else if (state.layout === 'split-3') {
      if (dom.previewImage) dom.previewImage.style.display = 'none';
      var w3 = document.createElement('div');
      w3.className = 'preview-split preview-split-3';
      var s3a = panelSrc(0) || primaryImage;
      var s3b = panelSrc(1) || s3a;
      var s3c = panelSrc(2) || s3b;
      w3.innerHTML = buildSplitPanel(s3a) + buildSplitPanel(s3b) + buildSplitPanel(s3c);
      if (dom.canvasFront) dom.canvasFront.appendChild(w3);
    } else if (state.layout === 'grid-4') {
      if (dom.previewImage) dom.previewImage.style.display = 'none';
      var w4 = document.createElement('div');
      w4.className = 'preview-grid-4';
      var s4a = panelSrc(0) || primaryImage;
      var s4b = panelSrc(1) || s4a;
      var s4c = panelSrc(2) || s4a;
      var s4d = panelSrc(3) || s4a;
      w4.innerHTML = buildSplitPanel(s4a) + buildSplitPanel(s4b) + buildSplitPanel(s4c) + buildSplitPanel(s4d);
      if (dom.canvasFront) dom.canvasFront.appendChild(w4);
    }

    // 3D update
    if (state.is3DMode && window.Fadelessart3D) {
      try { window.Fadelessart3D.updateFrame(state.frame.id); } catch(e) {}
    }
  }

  // ===========================================
  // ROOM PREVIEW -- shows user's image on wall
  // ===========================================
  function updateRoomPreview() {
    if (!dom.roomPreviewImg) return;
    var useAIImage = state.aiImage && state.aiImageStyle === state.filter.id;
    var imgSrc = useAIImage ? state.aiImage : state.image;
    if (!imgSrc) return;
    dom.roomPreviewImg.src = imgSrc;
    dom.roomPreviewImg.style.display = 'block';
    if (dom.roomCanvasOverlay) {
      var filterCss = useAIImage ? 'none' : (state.filter.css || 'none');
      dom.roomCanvasOverlay.style.setProperty('--room-filter', filterCss);
      dom.roomPreviewImg.style.filter = filterCss;
    }
  }

  // ===========================================
  // BOTTOM BAR -- pricing breakdown + quantity
  // ===========================================
  function updateBottomBar() {
    if (dom.bbSize) dom.bbSize.textContent = state.size.display;

    var sizePrice = state.size.price;
    var framePrice = state.frame.price;
    var filterPrice = state.filter.price;
    var servicePrice = state.service.price;
    var total = (sizePrice + framePrice + filterPrice + servicePrice) * state.quantity;

    if (dom.bbPrice) dom.bbPrice.textContent = '$' + total.toFixed(2);
    if (dom.bbOrig) dom.bbOrig.textContent = '$' + (state.size.orig * state.quantity).toFixed(2);

    // -- Add to Cart button total (must also stay in sync) --
    if (dom.bbFinal) dom.bbFinal.textContent = '$' + total.toFixed(2);

    // Breakdown
    if (dom.bbBreakSize) dom.bbBreakSize.textContent = 'Size: $' + sizePrice.toFixed(2);
    if (dom.bbBreakFrame) dom.bbBreakFrame.textContent = framePrice > 0 ? 'Frame: +$' + framePrice.toFixed(2) : '';
    if (dom.bbBreakFilter) dom.bbBreakFilter.textContent = filterPrice > 0 ? 'Art Style: +$' + filterPrice.toFixed(2) : '';
    if (dom.bbBreakService) dom.bbBreakService.textContent = servicePrice > 0 ? 'Service: +$' + servicePrice.toFixed(2) : '';

    // Show/hide breakdown items
    if (dom.bbBreakFrame) dom.bbBreakFrame.style.display = framePrice > 0 ? 'inline' : 'none';
    if (dom.bbBreakFilter) dom.bbBreakFilter.style.display = filterPrice > 0 ? 'inline' : 'none';
    if (dom.bbBreakService) dom.bbBreakService.style.display = servicePrice > 0 ? 'inline' : 'none';
  }

  // -- Quantity --
  function initQuantity() {
    if (dom.qtyMinus) {
      dom.qtyMinus.addEventListener('click', function() {
        if (state.quantity > 1) { state.quantity--; updateQuantity(); }
      });
    }
    if (dom.qtyPlus) {
      dom.qtyPlus.addEventListener('click', function() {
        if (state.quantity < 99) { state.quantity++; updateQuantity(); }
      });
    }
  }
  function updateQuantity() {
    if (dom.qtyInput) dom.qtyInput.value = state.quantity;
    updateBottomBar();
  }

  // ===========================================
  // TAB NAVIGATION -- true tab switch (Canvaspop style)
  // ===========================================
  function initTabNav() {
    var tabLinks = document.querySelectorAll('.tab-link');
    var panes = {
      sizes: $('pane-sizes'),
      edges: $('pane-edges'),
      layouts: $('pane-layouts'),
      frames: $('pane-frames'),
      filters: $('pane-filters'),
      services: $('pane-services')
    };
    function activate(tabName) {
      tabLinks.forEach(function(l) { l.classList.toggle('active', l.dataset.tab === tabName); });
      Object.keys(panes).forEach(function(k) {
        if (panes[k]) panes[k].classList.toggle('active', k === tabName);
      });
      if (dom.optionsPane) dom.optionsPane.scrollTop = 0;
    }
    tabLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        activate(link.dataset.tab);
      });
    });
    // expose for verification
    window.__fadelessartActivateTab = activate;
  }

  // ===========================================
  // CUSTOM SIZE -- dual dropdown (Canvaspop style)
  // ===========================================
  function initCustomSize() {
    if (!dom.customW || !dom.customH) return;

    // Populate options 8" - 72"
    var opts = '';
    for (var i = 8; i <= 72; i++) {
      opts += '<option value="' + i + '">' + i + '"</option>';
    }
    dom.customW.innerHTML = opts;
    dom.customH.innerHTML = opts;

    // Default: portrait 16"x20" aligned with default state.size
    dom.customW.value = '16';
    dom.customH.value = '20';

    function onChange() {
      var w = parseInt(dom.customW.value, 10);
      var h = parseInt(dom.customH.value, 10);
      if (!w || !h) return;
      applyCustomSize(w, h);
    }
    dom.customW.addEventListener('change', onChange);
    dom.customH.addEventListener('change', onChange);
  }

  // ===========================================
  // 3D PREVIEW TOGGLE
  // ===========================================
  function init3DToggle() {
    if (dom.toggle2DBtn) {
      dom.toggle2DBtn.addEventListener('click', function() {
        if (state.is3DMode) exit3DMode();
      });
    }
    if (dom.toggle3DBtn) {
      dom.toggle3DBtn.addEventListener('click', function() {
        if (!state.image) { showToast('Please upload a photo first', 'error'); return; }
        if (!state.is3DMode) enter3DMode();
      });
    }
    var rl = $('RotateLeft'), rr = $('RotateRight');
    if (rl) rl.addEventListener('click', function() { if (window.Fadelessart3D) window.Fadelessart3D.rotate(-0.2); });
    if (rr) rr.addEventListener('click', function() { if (window.Fadelessart3D) window.Fadelessart3D.rotate(0.2); });
  }

  function enter3DMode() {
    state.is3DMode = true;
    // Keep preview-stage visible; toggle inner 2D/3D wraps independently
    if (dom.previewCanvasWrap) dom.previewCanvasWrap.style.display = 'none';
    if (dom.preview3DContainer) dom.preview3DContainer.style.display = 'flex';
    if (dom.rotationControls) dom.rotationControls.style.display = 'flex';
    if (dom.toggle2DBtn) dom.toggle2DBtn.classList.remove('active');
    if (dom.toggle3DBtn) dom.toggle3DBtn.classList.add('active');

    // Wait for browser to calculate dimensions before initializing Three.js
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        if (window.Fadelessart3D) {
          try {
            // Sync the 3D size label to mirror the 2D one
            var lbl2d = $('PreviewSizeLabel');
            var lbl3d = $('Preview3DSizeLabel');
            if (lbl2d && lbl3d) {
              lbl3d.innerHTML = lbl2d.innerHTML;
            }
            var stage3d = $('Preview3DContainer');
            if (stage3d) {
              var ratio = window.getComputedStyle(stage3d).aspectRatio || '3 / 4';
              // Pass the inner .preview-3d-stage element so three-preview-v2.js can size off it
              var stage = stage3d.querySelector('.preview-3d-stage');
              window.Fadelessart3D.init({
                canvas: $('ThreeCanvas'), imageSrc: state.image,
                frame: state.frame.id, size: state.size.display, productType: 'canvas',
                stageEl: stage
              });
            } else {
              window.Fadelessart3D.init({
                canvas: $('ThreeCanvas'), imageSrc: state.image,
                frame: state.frame.id, size: state.size.display, productType: 'canvas'
              });
            }
          } catch(e) {
            console.error('3D init error:', e);
            showToast('3D preview unavailable. Please try 2D mode.', 'error');
            exit3DMode();
          }
        } else {
          console.warn('Fadelessart3D not loaded');
          showToast('3D engine still loading. Please try again in a moment.', 'error');
          exit3DMode();
        }
      });
    });
  }

  function exit3DMode() {
    state.is3DMode = false;
    if (dom.previewCanvasWrap) dom.previewCanvasWrap.style.display = '';
    if (dom.preview3DContainer) dom.preview3DContainer.style.display = 'none';
    if (dom.rotationControls) dom.rotationControls.style.display = 'none';
    if (dom.toggle2DBtn) dom.toggle2DBtn.classList.add('active');
    if (dom.toggle3DBtn) dom.toggle3DBtn.classList.remove('active');
    if (window.Fadelessart3D) {
      try { window.Fadelessart3D.destroy(); } catch(e) {}
    }
    // Re-render 2D preview
    updatePreview();
  }

  // ===========================================
  // MAGNIFIER LENS — hover-to-zoom detail viewer
  // ===========================================
  function initMagnifier() {
    // Skip on touch devices — no hover interaction
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) return;
    if (!dom.previewStage) return;

    var ZOOM = 2.5;
    var LENS_SIZE = 180;

    // Create lens element
    var lens = document.createElement('div');
    lens.className = 'magnifier-lens';
    lens.id = 'MagnifierLens';
    dom.previewStage.appendChild(lens);

    // Create hint badge
    var hint = document.createElement('div');
    hint.className = 'magnifier-hint';
    hint.textContent = 'Hover image to zoom \u00d7' + ZOOM;
    dom.previewStage.appendChild(hint);

    var hintShown = false;

    function getTargetImage(e) {
      var t = e.target;
      if (t && t.tagName === 'IMG' && t.src && t.style.display !== 'none') return t;
      var cf = t && t.closest && t.closest('.canvas-front, .preview-split, .preview-grid-4');
      if (cf) {
        var img = cf.querySelector('img');
        if (img && img.src) return img;
      }
      return null;
    }

    function handleMove(e) {
      var imgEl = getTargetImage(e);
      if (!imgEl || !state.image) { lens.style.display = 'none'; return; }

      var rect = imgEl.getBoundingClientRect();
      if (rect.width < 2 || rect.height < 2) return;

      var mx = e.clientX - rect.left;
      var my = e.clientY - rect.top;
      if (mx < 0 || mx > rect.width || my < 0 || my > rect.height) {
        lens.style.display = 'none'; return;
      }

      var stageRect = dom.previewStage.getBoundingClientRect();
      lens.style.display = 'block';
      lens.style.left = (e.clientX - stageRect.left - LENS_SIZE / 2) + 'px';
      lens.style.top = (e.clientY - stageRect.top - LENS_SIZE / 2) + 'px';
      lens.style.backgroundImage = 'url("' + imgEl.src + '")';
      lens.style.backgroundSize = (rect.width * ZOOM) + 'px ' + (rect.height * ZOOM) + 'px';
      lens.style.backgroundPosition = (-(mx * ZOOM - LENS_SIZE / 2)) + 'px ' + (-(my * ZOOM - LENS_SIZE / 2)) + 'px';

      // Match CSS filter (AI images already have filter baked in)
      var useAI = state.aiImage && state.aiImageStyle === state.filter.id;
      lens.style.filter = useAI ? 'none' : (state.filter.css || 'none');
    }

    function handleEnter() {
      if (state.image && !hintShown) {
        hintShown = true;
        hint.classList.add('visible');
        setTimeout(function() { hint.classList.remove('visible'); }, 2800);
      }
    }

    function handleLeave() {
      lens.style.display = 'none';
    }

    if (dom.canvasFront) {
      dom.canvasFront.addEventListener('mousemove', handleMove);
      dom.canvasFront.addEventListener('mouseenter', handleEnter);
      dom.canvasFront.addEventListener('mouseleave', handleLeave);
    }
  }

  // ===========================================
  // ADD TO CART -- uses real Shopify variant ID
  // ===========================================
  function initAddToCart() {
    if (!dom.addToCartBtn) return;
    dom.addToCartBtn.addEventListener('click', async function() {
      if (!state.image) { showToast('Please upload an image first', 'error'); return; }
      if (!state.size.variant) { showToast('Please select a size', 'error'); return; }

      dom.addToCartBtn.disabled = true;
      var origText = dom.addToCartBtn.textContent;
      dom.addToCartBtn.textContent = 'Adding to cart...';

      try {
        state.notes = dom.designerNotes ? dom.designerNotes.value : '';
        var layoutName = state.layout === 'single' ? 'Single panel' :
          state.layout === 'split-2' ? '2-panel split' :
          state.layout === 'split-3' ? '3-panel triptych' : '4-panel grid';

        var properties = {
          'Customization ID': 'FA-' + Date.now().toString(36).toUpperCase(),
          'Size': state.size.display,
          'Orientation': state.orientation.charAt(0).toUpperCase() + state.orientation.slice(1),
          'Layout': layoutName,
          'Panels': String(panelCountFor(state.layout)),
          'Edge Style': state.edge.name,
          'Canvas Depth': state.depth + '" deep canvas wrap',
          'Frame Style': state.frame.name,
          'Photo Filter': state.filter.name,
          'AI Processed': state.aiImage ? 'Yes (' + state.aiImageStyle + ')' : 'No',
          'Edit Service': state.service.name,
          'Image 1 Source': state.image ? 'uploaded' : 'none'
        };
        // Custom dimensions (when custom size chosen)
        if (state.isCustomSize || /\d{1,2}"/.test(state.size.display) === false) {
          // heuristic: display starts with a number pair we can parse
          var m = String(state.size.display).match(/(\d+)\"?\s*x\s*(\d+)/);
          if (m) properties['Custom Width (in)'] = m[1], properties['Custom Height (in)'] = m[2];
        }
        // Per-panel image presence
        var pi = state.panelImages || [];
        pi.forEach(function(url, idx) {
          if (url) properties['Panel ' + (idx + 1) + ' Image'] = 'uploaded';
        });
        if (state.imageWidth && state.imageHeight) {
          properties['Image Resolution'] = state.imageWidth + 'x' + state.imageHeight + 'px';
          properties['Image Quality'] = state.imageQuality || 'unknown';
        }
        // Designer Notes (top page-level)
        if (state.notes) properties['Designer Notes'] = state.notes;
        // Adjustment Notes from services textarea (separate field)
        var adjNotesEl = document.getElementById('adjustmentNotes');
        if (adjNotesEl && adjNotesEl.value && adjNotesEl.value.trim()) {
          properties['Adjustment Notes'] = adjNotesEl.value.trim();
        }

        // Use AI-processed image URL if available (already on R2 from AI processing)
        // Otherwise upload original image to backend
        var imageUrl = '';
        if (state.aiImage && state.aiImageStyle === state.filter.id) {
          // AI image is already uploaded to R2 by the style-transfer endpoint
          if (state.aiImage.startsWith('http')) {
            imageUrl = state.aiImage;
          } else {
            // Data URL fallback — upload to R2
            try {
              var uploadRes = await fetch(API_BASE_URL + '/api/upload', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ image: state.aiImage })
              });
              if (uploadRes.ok) { var d = await uploadRes.json(); imageUrl = d.url || ''; }
            } catch(e) { console.warn('AI image upload skipped:', e); }
          }
          if (imageUrl) properties['_ai_image_url'] = imageUrl;
        }

        // Always upload original image too (for print reference)
        try {
          var uploadRes2 = await fetch(API_BASE_URL + '/api/upload', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ image: state.image })
          });
          if (uploadRes2.ok) { var d2 = await uploadRes2.json(); if (!imageUrl) imageUrl = d2.url || ''; }
        } catch(e) { console.warn('Image upload skipped:', e); }
        if (imageUrl) properties['_image_url'] = imageUrl;

        // Add to Shopify cart with REAL variant ID
        var formData = {
          items: [{
            quantity: state.quantity,
            id: state.size.variant,
            properties: properties
          }]
        };

        var cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';
        var response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(formData)
        });

        if (!response.ok) throw new Error('Failed to add to cart');

        var total = (state.size.price + state.frame.price + state.filter.price + state.service.price) * state.quantity;
        showToast('Added to cart -- $' + total.toFixed(2), 'success');
        setTimeout(function() {
          window.location.href = (window.theme && window.theme.cartUrl) || '/cart';
        }, 1500);
      } catch(err) {
        console.error('Add to cart error:', err);
        showToast('Failed to add to cart. Please try again.', 'error');
        dom.addToCartBtn.disabled = false;
        dom.addToCartBtn.textContent = origText;
      }
    });
  }

  // -- Toast --
  function showToast(message, type) {
    var container = document.querySelector('.toast-container');
    if (!container) { alert(message); return; }
    var toast = document.createElement('div');
    toast.className = 'toast toast--' + (type || 'info');
    toast.textContent = message;
    container.appendChild(toast);
    setTimeout(function() { toast.classList.add('show'); }, 10);
    setTimeout(function() {
      toast.classList.remove('show');
      setTimeout(function() { toast.remove(); }, 300);
    }, 3500);
  }

  // ===========================================
  // Mobile: Sync header height to CSS var so floating preview offsets correctly
  // ===========================================
  function syncMobileHeaderHeight() {
    if (window.innerWidth > 768) {
      document.documentElement.style.removeProperty('--mobile-header-h');
      return;
    }
    var header = document.querySelector('.site-header');
    var bar = document.querySelector('.announcement-bar');
    var total = 0;
    if (header) total += header.getBoundingClientRect().height;
    if (bar) total += bar.getBoundingClientRect().height;
    if (!total) total = 56;
    document.documentElement.style.setProperty('--mobile-header-h', Math.round(total) + 'px');
  }

  // ===========================================
  // INIT
  // ===========================================
  function init() {
    console.log('[Fadelessart Customizer] Initializing...');
    cacheDom();

    // Mobile: measure header height so floating preview sits right below it
    syncMobileHeaderHeight();
    window.addEventListener('resize', syncMobileHeaderHeight);
    setTimeout(syncMobileHeaderHeight, 250);  // re-check after layout settles
    
    // Verify critical DOM elements exist
    var missingElements = [];
    var criticalIds = ['UploadZone', 'FileInput', 'PreviewCanvasWrap', 'PreviewImage', 'FrameOuter', 'CanvasEdge', 'CanvasFront', 'SizeGrid', 'AddToCartBtn'];
    criticalIds.forEach(function(id) {
      if (!$(id)) missingElements.push(id);
    });
    if (missingElements.length > 0) {
      console.error('[Customizer] Missing DOM elements:', missingElements.join(', '));
    }
    
    // Parse variant data
    if (!Object.keys(VARIANT_MAP).length) {
      console.error('[Customizer] VariantData not found or empty!');
    } else {
      console.log('[Customizer] Variant data loaded:', Object.keys(VARIANT_MAP).map(function(k){ return k + ':' + (VARIANT_MAP[k]||[]).length + ' sizes'; }).join(', '));
    }
    
    try {
      initUpload();
      initOrientation();
      initLayout();
      rebuildUploadSlots();  // build initial 1 slot for single-panel layout
      initCustomSize(); // populate dropdown options + bind change -> applyCustomSize
      initCustomSizeToggle();
      initEdge();
      initFrame();
      initFilter();
      initService();
      initTabNav();
      init3DToggle();
      initMagnifier();
      initQuantity();
      initAddToCart();

      updatePreview();
      updateBottomBar();
      console.log('[Customizer] Init complete. Ready for interaction.');
    } catch(e) {
      console.error('[Customizer] Init error:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
